import component from './Spinner';

export const Spinner: any = component;
